let selected_year_modal , selected_make_modal , selected_model_modal;

class sideymmJS extends HTMLElement {
    constructor() {
        super();
        this.initJsonData();
    }

    async initJsonData(){
        let json = await vehicleUtility.tsvsideJSON();
        this.initVehicle(json);
      }

    initVehicle(json){
        this.vehicleJsonData = json;
        this.defaultMaterial = window.globalVariables.default_material;

        this.selectedPartNumber = [];

        this.uniqueYears = [
            ...new Set(Object.values(this.vehicleJsonData).map((item) => item.year)),
        ];
        this.uniqueMake = [
            ...new Set(Object.values(this.vehicleJsonData).map((item) => item.make))
        ];
        this.uniqueModels = [
            ...new Set(Object.values(this.vehicleJsonData).map((item) => item.model)),
        ];

        this.uniqueParts = [
            ...new Set(Object.values(this.vehicleJsonData).map((item) => item.part_number))
        ];
       
        this.uniqueRows = [
            ...new Set(Object.values(this.vehicleJsonData).map((item) => item.row))
        ];

        this.yearSelect = this.querySelector("[data-side-year-filter-select]");
    
        this.makeSelect = this.querySelector("[data-side-make-filter-select]");
      
        this.modelSelect = this.querySelector("[data-side-modal-filter-select]");

        this.partSelect = document.querySelector("[data-side-modal-filter-select]");

        this.rowSelect = document.querySelector("[data-side-row-filter-select]");

        let yearHTML = '';

        this.uniqueYears.sort().reverse().forEach((years) => {
            if( years != null){
                yearHTML += `
                <li class="for-check" data-value="${years}">
                    <input type="radio" class="ymm-input form-check-input d-none" data-label="${years}" value="${years}" id="year-side-${years}" name="year-side-filter"/>
                    <label class="option_txt form-check-label text-capitalize" for="year-side-${years}" title="Label for ${years}">${years}</label>
                </li>
                `;
            }
        });
     
        if(this.yearSelect != null){
            this.yearSelect.innerHTML = yearHTML 
            this.yearOptions = this.yearSelect.querySelectorAll('li');
            this.yearOptions.forEach((option) => {
                option.addEventListener('click', (event) => {
                    let _this = event.currentTarget;
                    this.yearOptions.forEach(option => option.classList.remove('selected'));
                    _this.classList.add('selected');
                    _this.closest('.custom-dropdown').querySelector('.year-default .option_txt').innerHTML = _this.querySelector('.option_txt').innerHTML;
                    //document.querySelector('.year-default .option_txt').innerHTML = _this.querySelector('.option_txt').innerHTML;
                    this.selectContainer = _this.closest('.custom--select');
                    Utility.toggleElement(this.selectContainer, 'close');
                });
            }) 
    
            // Add event listener to the year select element
            this.yearInputs = this.querySelectorAll('[data-side-year-filter-select] input');
            let yearInputs = this.yearSelect.querySelectorAll('input');
            
            yearInputs.forEach((yearInput) => {
                yearInput.addEventListener('change', (event) => {

                    let currentvalue = this.querySelector('[data-side-year-filter-select] [name="year-side-filter"]:checked').value;
                    let currentvalueLable = this.querySelector('[data-side-year-filter-select] [name="year-side-filter"]:checked').getAttribute('data-label');

                    let els = document.querySelectorAll('shop-side-by-side');
                    els.forEach(el => {
                        el.querySelector('.make-default .option_txt').innerHTML = 'Make';
                        el.querySelector('.model-default .option_txt').innerHTML = 'Model';
                        el.querySelector('[data-side-model-wrap] .custom-dropdown').classList.add('disabled');
                        el.modelSelect.innerHTML = '';
                        el._updateMakes(currentvalueLable);
                    });
                    
                })
            });
             // Add a click event listener to the 'shopVehicleBtn'
            const shopVehicleBtn = this.querySelector('[data-shop-side-vehicle-btn]');
            shopVehicleBtn?.addEventListener('click', (event) => {
                event.target.closest('.btn').classList.add('loading');
                var isCustomer = document.body.classList.contains('customer-loggedin');
                var isCustomerB2B = document.body.classList.contains('b2b-customer');
        
                if(isCustomer && !isCustomerB2B){
                    this._addVehicle();
                } else if(isCustomer && isCustomerB2B) {
                    this._searchVehicle();
                } else {
                    this._addVehicle();
                }
            });
        }
       
        // Determine if the user is a customer based on a class
        vehicleUtility._deterMineVehicles();
        this.selectedYMMData = window.customerSelectedVehicles.vehicle
        this.selectedHeavyEqipData =  window.customerSelectedVehicles.heavyVehicle
        this.selectedSideYMMData = window.customerSelectedVehicles.sidebyside
        this.selectedTrufData = window.customerSelectedVehicles.turf

        //Store data in list
        // this._listVehicle();
        this.defaultVehicle = false;
        if(this.selectedHeavyEqipData.length > 0){
           this.selectedHeavyEqipData.forEach((selectedHQ) => {
               if(selectedHQ.default == true){
                   this.defaultVehicle = false;
               }
            })
        } else {
           // Determine if it's the default vehicle
           this.defaultVehicle = this.selectedYMMData.length === 0;
        }


        // this.defaultVehicle = false;

        // if(this.selectedYMMData.length > 0){
        //    this.selectedYMMData.forEach((selectedYMM) => {
        //        if(selectedYMM.default == true){
        //            this.defaultVehicle = false;
        //        }
        //    })
        // } else {
        //    // Determine if it's the default vehicle
        //    this.defaultVehicle = this.selectedHeavyEqipData.length === 0;
        // }

        // End Change Account vehicle
        this._toggleAllDropdown();
    }

    _toggleAllDropdown(){
        document.querySelectorAll('[data-main-category]').forEach(element => {
            element.addEventListener('click', (event) => {            
                this.querySelector('[data-side-make-wrap] .custom-dropdown .custom--select').classList.remove('open');
                this.querySelector('[data-side-model-wrap] .custom-dropdown .custom--select').classList.remove('open');
                this.querySelector('[data-side-make-wrap] .custom-dropdown.custom--select').classList.remove('open');
                this.querySelector('[data-side-model-wrap] .custom-dropdown.custom--select').classList.remove('open');
                this.querySelector('[data-side-make-wrap] .custom-dropdown .custom--select .toggle-content').classList.remove('open');
                this.querySelector('[data-side-model-wrap] .custom-dropdown .custom--select .toggle-content').classList.remove('open');

                this.querySelector('[data-side-year-wrap] .custom-dropdown .custom--select').classList.remove('open');
                this.querySelector('[data-side-year-wrap] .custom-dropdown.custom--select').classList.remove('open');
                this.querySelector('[data-side-year-wrap] .custom-dropdown .custom--select .toggle-content').classList.remove('open');
            });
        });


        this.querySelector('[data-side-make-wrap] .custom-dropdown')?.addEventListener('click', (event) => {
            this.querySelector('[data-side-year-wrap] .custom-dropdown .custom--select').classList.remove('open');
            this.querySelector('[data-side-model-wrap] .custom-dropdown .custom--select').classList.remove('open');
            this.querySelector('[data-side-year-wrap] .custom-dropdown.custom--select').classList.remove('open');
            this.querySelector('[data-side-model-wrap] .custom-dropdown.custom--select').classList.remove('open');
            this.querySelector('[data-side-year-wrap] .custom-dropdown .custom--select .toggle-content').classList.remove('open');
            this.querySelector('[data-side-model-wrap] .custom-dropdown .custom--select .toggle-content').classList.remove('open');
        });

        this.querySelector('[data-side-model-wrap] .custom-dropdown')?.addEventListener('click', (event) => {
            this.querySelector('[data-side-year-wrap] .custom-dropdown .custom--select').classList.remove('open');
            this.querySelector('[data-side-make-wrap] .custom-dropdown .custom--select').classList.remove('open');
            this.querySelector('[data-side-year-wrap] .custom-dropdown.custom--select').classList.remove('open');
            this.querySelector('[data-side-make-wrap] .custom-dropdown.custom--select').classList.remove('open');
            this.querySelector('[data-side-year-wrap] .custom-dropdown .custom--select .toggle-content').classList.remove('open');
            this.querySelector('[data-side-make-wrap] .custom-dropdown .custom--select .toggle-content').classList.remove('open');
        });

        this.querySelector('[data-side-year-wrap] .custom-dropdown')?.addEventListener('click', (event) => {
            this.querySelector('[data-side-make-wrap] .custom-dropdown .custom--select').classList.remove('open');
            this.querySelector('[data-side-model-wrap] .custom-dropdown .custom--select').classList.remove('open');
            this.querySelector('[data-side-make-wrap] .custom-dropdown.custom--select').classList.remove('open');
            this.querySelector('[data-side-model-wrap] .custom-dropdown.custom--select').classList.remove('open');
            this.querySelector('[data-side-make-wrap] .custom-dropdown .custom--select .toggle-content').classList.remove('open');
            this.querySelector('[data-side-model-wrap] .custom-dropdown .custom--select .toggle-content').classList.remove('open');
        });

    }

    _searchVehicle(){
        let selectedYear = this.querySelector('[data-side-year-filter-select] [name="year-side-filter"]:checked').value;
        let selectedMake = this.querySelector('[data-side-make-filter-select] [name="ymm-filter-side-make"]:checked').value;
        let selectedModel = this.querySelector('[data-side-modal-filter-select] [name="ymm-filter-side-models"]:checked').value;

        var prefixedParts = this.selectedPartNumber.map(function(element) {
            let partNum = element;
            return "sku-" + partNum;
        });
        var partsNumber = prefixedParts.join(",");
        this._redirectToParts(partsNumber);
        
    }

    _redirectToParts(partsNumber){
        window.location.href=`/collections/side-by-side-seat-covers?filter.p.tag=${partsNumber}`;
    }
    
    _addVehicle(){
        var prefixedParts = this.selectedPartNumber.map(function(element) {
            let partNum = element;
            return "sku-" + partNum;
        });
        var partsNumber = prefixedParts.join(",");

        const isCustomer = document.body.classList.contains('customer-loggedin');
        // const isCustomerB2B = document.body.classList.contains('b2b-customer');
        let selectedYear = selected_year_modal;
        let selectedMake = selected_make_modal;
        let selectedModel = selected_model_modal;
       
        let selectedData;
        var isVehicleAdded = this.selectedYMMData.some((selectedVehicle) => {
            return selectedVehicle.year === selectedYear && 
                    selectedVehicle.make === selectedMake && 
                    selectedVehicle.model === selectedModel 
        });
        
    
        const min = 1000;
        const max = 5000;
        const randomNum = Math.floor(Math.random() * (max - min + 1)) + min;
    
        if(!isVehicleAdded){
            if(isCustomer){
                selectedData = {
                    "id": randomNum,
                    "year":selectedYear,
                    "make":selectedMake,
                    "model":selectedModel
                }

                this.selectedSideYMMData.push(selectedData);
                localStorage.setItem('currentSelectedData', JSON.stringify(selectedData))
                localStorage.setItem('currentSelectedDataLabels', JSON.stringify(selectedData))

                //shopifyFormUtility._shopifySideFormSubmit(this.selectedSideYMMData,partsNumber);

                shopifyFormUtility._updateCustomerSideMeta(this.selectedSideYMMData,partsNumber);



                setTimeout(() => {
                    let vehicleMeta = document.querySelector('[data-vehile-customer-metafields] [data-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedYMMData = vehicleMeta != '' ? JSON.parse(vehicleMeta) : [];
                  
                    let heavyMeta = document.querySelector('[data-vehile-customer-metafields] [data-hevay-equp-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedHeavyEqipData = heavyMeta != '' ? JSON.parse(heavyMeta) : [];

                    let sideMeta = document.querySelector('[data-vehile-customer-metafields] [data-side-vehicle-meta]').textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    this.selectedSideYMMData = sideMeta != '' ? JSON.parse(sideMeta) : [];

                    localStorage.removeItem('vehicle_data');
                    localStorage.removeItem('vehicle_data_side');
                    localStorage.removeItem('heavy_equipment_data');
                    vehicleUtility._listVehicle();
                    this._redirectToParts(partsNumber);
                   

                    this.querySelector('[data-shop-side-vehicle-btn]')?.classList.remove('loading');
                    this.querySelector('[data-shop-side-vehicle-btn-new]')?.classList.remove('loading');
                  
                },3000);

                
            }  else {
                selectedData = {
                        "id": randomNum,
                        "year":selectedYear,
                        "make":selectedMake,
                        "model":selectedModel,
                        "default":this.defaultVehicle,
                }

                this.selectedSideYMMData.push(selectedData);
                let selectedYearLabel = selected_year_modal;
                let selectedMakeLabel = selected_make_modal;
                let selectedModelLabel = selected_model_modal;
               
                var selectedDataLabel = {
                    "id": randomNum,
                    "year":selectedYearLabel,
                    "make":selectedMakeLabel,
                    "model":selectedModelLabel
                }

                localStorage.setItem('currentSelectedDataLabels', JSON.stringify(selectedDataLabel));
                localStorage.setItem('currentSelectedData', JSON.stringify(selectedData));
                localStorage.setItem('vehicle_data_side', JSON.stringify(this.selectedSideYMMData));

                const addedHeavyData = localStorage.getItem('heavy_equipment_data');
                this.selectedHeavyEqipData = addedHeavyData ? JSON.parse(addedHeavyData) : [];
                
                const addedVehicleData = localStorage.getItem('vehicle_data');
                this.selectedYMMData = addedVehicleData ? JSON.parse(addedVehicleData) : [];

                const addedSideData = localStorage.getItem('vehicle_data_side');
                this.selectedsideYMMData = addedSideData ? JSON.parse(addedSideData) : [];

                vehicleUtility._listVehicle();                
                this._redirectToParts(partsNumber);
                
                setTimeout(() => {
                    this.querySelector('[data-shop-side-vehicle-btn]')?.classList.remove('loading');
                    this.querySelector('[data-shop-side-vehicle-btn-new]')?.classList.remove('loading');
                },3000);
            }
        } else {
            this._redirectToParts(partsNumber);
        }
    }

    _updateDropdown(){
        // Start Make Dropdown Event
        this.makeSelectInput = document.querySelectorAll('[data-side-make-filter-select] input');

        this.makeSelectInput.forEach((makeInput) => {
            makeInput.addEventListener('change', (event) => {
                let _this = event.currentTarget;
                this.querySelector('[data-shop-side-vehicle-btn]')?.classList.add('disabled');
                document.querySelector('[data-shop-side-vehicle-btn-new]')?.classList.add('disabled');
                document.querySelector('[data-pdp-edit-vehicle-btn]')?.classList.add('disabled');
                document.querySelector('[data-edit-shop-vehicle-btn]')?.classList.add('disabled');

                let currentvalue = document.querySelector('[data-side-make-filter-select] [name="ymm-filter-side-make"]:checked').value;
                let currentvalueLable =  document.querySelector('[data-side-make-filter-select] [name="ymm-filter-side-make"]:checked').getAttribute('data-label');

                let els = document.querySelectorAll('shop-side-by-side');
                els.forEach(el => {
                    el.querySelector('.model-default .option_txt').innerHTML = 'Model';
                    el.querySelector('[data-shop-side-vehicle-btn]')?.classList.add('disabled');
                    el._updateModel(currentvalueLable);
                });
            })
        });

        this.makeOptions = this.makeSelect.querySelectorAll('li');
        this.makeOptions.forEach((option) => {
            option.addEventListener('click', (event) => {
                let _this = event.currentTarget;
                this.makeOptions.forEach(option => option.classList.remove('selected'));
                _this.classList.add('selected');
                _this.closest('.custom-dropdown').querySelector('.make-default .option_txt').innerHTML = _this.querySelector('.option_txt').innerHTML;
                this.selectContainer = _this.closest('.custom--select');
                Utility.toggleElement(this.selectContainer, 'close');
            });
        }) 

        //End Make Dropdown Event


        //Start Model Dropdown Event
        this.modalSelectInput = this.modelSelect.querySelectorAll('[data-side-modal-filter-select] input');
        this.modalSelectInput.forEach((modelInput) => {
            modelInput.addEventListener('change', (event) => {
                let _this = event.currentTarget;
                this.querySelector('[data-shop-side-vehicle-btn]')?.classList.remove('disabled');
                document.querySelector('[data-shop-side-vehicle-btn-new]')?.classList.remove('disabled');
                document.querySelector('[data-pdp-edit-vehicle-btn]')?.classList.remove('disabled');
                document.querySelector('[data-edit-shop-vehicle-btn]')?.classList.remove('disabled');

                let currentvalue = document.querySelector('[data-side-modal-filter-select] [name="ymm-filter-side-models"]:checked').value;
                let currentvalueLabel = document.querySelector('[data-side-modal-filter-select] [name="ymm-filter-side-models"]:checked').getAttribute('data-label');

                let els = document.querySelectorAll('shop-side-by-side');
                els.forEach(el => {
                    el._updateRow(el.querySelector('[data-side-row-filter-select]'));
                    el._updateParts(el.querySelector('[data-part-side-filter-select]'));
                    el.querySelector('[data-shop-side-vehicle-btn]')?.classList.remove('disabled');
                   
                });
            })
        });

        this.modelOptions = this.modelSelect.querySelectorAll('li');
        this.modelOptions.forEach((option) => {
            option.addEventListener('click', (event) => {
                let _this = event.currentTarget;
                this.modelOptions.forEach(option => option.classList.remove('selected'));
                _this.classList.add('selected');
                _this.closest('.custom-dropdown').querySelector('.model-default .option_txt').innerHTML = _this.querySelector('.option_txt').innerHTML;
                this.selectContainer = _this.closest('.custom--select');
                Utility.toggleElement(this.selectContainer, 'close');
            });
        }) 
        //End Model Dropdown Event

    }

    _populateSelectParts(select, options, selectBoxName){
        select.innerHTML = "";
        let optionHTML = "";

        options.sort().forEach((option) => {
            if (option != null) {
            let optionVal = Utility._createSlug(option)
            optionHTML += `
            <li class="for-check" data-value="${option}">
                <input type="radio" class="ymm-input form-check-input d-none" value="${option}" data-label="${option}" data-value="${option}" id="year-side-${option}" name="ymm-filter-side-${selectBoxName}"/>
                <label class="option_txt form-check-label w-100 text-capitalize" for="year-side-${option}" title="Label for ${option}">${option}</label>
            </li>`;
           
          } 
        });
       
        select.innerHTML = optionHTML;
        this._updateDropdown();
    }

    _populateSelect(select, options, selectBoxName){

        select.innerHTML = "";
        let optionHTML = "";

            options.sort().forEach((option) => {
                if (option != null) {
                  let optionVal = Utility._createSlug(option);
                  optionHTML += `
                  <li class="for-check" data-value="${option}">
                      <input type="radio" class="ymm-input form-check-input d-none" value="${option}" data-label="${option}" data-value="${option}" id="year-${option}" name="ymm-filter-side-${selectBoxName}"/>
                      <label class="option_txt form-check-label w-100 text-capitalize" for="year-${option}" title="Label for ${option}">${option}</label>
                  </li>`;
                  select.removeAttribute('disabled','disabled');
                  select.closest('.custom-dropdown').classList.remove('disabled')
                } else {
                //   this.trimSelect.innerHTML = "";
                  // select.setAttribute('disabled','disabled');
                  // select.closest('.custom-dropdown').classList.add('disabled')
                  // this.querySelector('[data-trim-wrap]').classList.add('d-none');
                  // this.querySelector('[data-cab-wrap]').classList.add('d-none');
                }
            });
        
    
        select.innerHTML = optionHTML;
        this._updateDropdown();
      
       
    }

    _updateMakes(inputValue){
        const selectedYear = inputValue;
        selected_year_modal = selectedYear;

        // Filter available options based on user selections
        const filteredMakes = this.uniqueYears.includes(selectedYear)
            ? [
                ...new Set(
                Object.values(this.vehicleJsonData)
                    .filter((item) => item.year === selectedYear)
                    .map((item) => item.make)
                ),
            ]
            : this.uniqueYears;
       

        // Populate the selects with filtered options
        this._populateSelect(this.makeSelect, filteredMakes, 'make');
    }

    _updateModel() {
        let selectedYear = document.querySelector('[data-side-year-filter-select] [name="year-side-filter"]:checked').getAttribute('data-label');
        let selectedMake = document.querySelector('[data-side-make-filter-select] [name="ymm-filter-side-make"]:checked').getAttribute('data-label');
         selected_make_modal = selectedMake;
        
        const filteredModels =
          selectedMake !== ""
            ? [
                ...new Set(
                  Object.values(this.vehicleJsonData)
                    .filter(
                      (item) =>
                        item.year === selectedYear && item.make === selectedMake
                    )
                    .map((item) => item.model)
                ),
              ]
            : this.uniqueModels;
       
        this._populateSelect(this.modelSelect, filteredModels, 'models');
    }

    _updateRow(rowSelect) {
        let selectedYear = document.querySelector('[data-side-year-filter-select] [name="year-side-filter"]:checked').getAttribute('data-label');
        let selectedMake = document.querySelector('[data-side-make-filter-select] [name="ymm-filter-side-make"]:checked').getAttribute('data-label');
        let selectedModel = document.querySelector('[data-side-modal-filter-select] [name="ymm-filter-side-models"]:checked').getAttribute('data-label');
        selected_model_modal = selectedModel;
      
        let filteredRows;
        filteredRows =
                selectedModel !== ""
                ? [
                    ...new Set(
                        Object.values(this.vehicleJsonData)
                        .filter(
                            (item) =>
                            item.year === selectedYear &&
                            item.make === selectedMake &&
                            item.model === selectedModel 
                        )
                        .map((item) => item.row)
                    ),
                    ]
                : this.uniqueRows;

        this._populateSelectRow(rowSelect, filteredRows, 'row');
    }

    _updateParts(partSelect){

        let selectedYear = document.querySelector('[data-side-year-filter-select] [name="year-side-filter"]:checked').getAttribute('data-label');
        let selectedMake = document.querySelector('[data-side-make-filter-select] [name="ymm-filter-side-make"]:checked').getAttribute('data-label');
        let selectedModel = document.querySelector('[data-side-modal-filter-select] [name="ymm-filter-side-models"]:checked').getAttribute('data-label');

        let uniquePartNumbers = [];
        let filteredParts = [];
        let rowEls = this.querySelectorAll('[data-side-row-filter-select] li');
        if (rowEls.length > 0) {
            rowEls.forEach((row) => {
                let rowValue = row.getAttribute('data-value');
                let filteredParts;
                filteredParts = [
                    ...new Set(
                        Object.values(this.vehicleJsonData)
                            .filter(
                                (item) =>
                                    item.year === selectedYear &&
                                    item.make === selectedMake &&
                                    item.model === selectedModel &&
                                    item.row === rowValue
                            )
                            .map((item) => item.part_number)
                    ),
                ];

                // Add the unique part numbers to the result array
                uniquePartNumbers.push(...filteredParts);
            });
        }
        else{
            let filteredParts;
            filteredParts = [
                ...new Set(
                    Object.values(this.vehicleJsonData)
                        .filter(
                            (item) =>
                                item.year === selectedYear &&
                                item.make === selectedMake &&
                                item.model === selectedModel 
                        )
                        .map((item) => item.part_number)
                ),
            ];
      
          // Add the unique part numbers to the result array
          uniquePartNumbers.push(...filteredParts);
          }

                // Add the unique part numbers to the result array
                uniquePartNumbers.push(...filteredParts);

        // Remove duplicates from the result array
        uniquePartNumbers = [...new Set(uniquePartNumbers)];
        this.selectedPartNumber = uniquePartNumbers;
        localStorage.setItem('partNumbers', JSON.stringify(uniquePartNumbers));
        this._populateSelectParts(partSelect, uniquePartNumbers, 'part');
        
    }

    _populateSelectRow(select, options, selectBoxName){
        select.innerHTML = "";
        let optionHTML = "";
        options.sort().forEach((option) => {
          if (option !== null) {
            let optionVal = Utility._createSlug(option);
            this.querySelector('[data-side-row-wrap]').classList.add('d-none');
            optionHTML += `
            <li class="for-check" data-value="${option}">
                <input type="radio" class="ymm-input form-check-input d-none" value="${option}" data-label="${option}" data-value="${option}" id="year-side-${option}" name="ymm-filter-side-${selectBoxName}"/>
                <label class="option_txt form-check-label w-100 text-capitalize" for="year-side-${option}" title="Label for ${option}">${option}</label>
            </li>`;
          } 
        });
        select.innerHTML = optionHTML;
        this._updateDropdown();
    }

}

customElements.define('shop-side-by-side', sideymmJS);
